/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommsSettings/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import Settings from './Settings/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommsSettings({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsSettings"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="CommsSettings.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-BDrNi': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-2-BDrNi': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CommsSettings.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Comms Settings"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Manage the comms settings for each location"
/>
</div>
<div
  data-testid="CommsSettings.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="CommsSettings.Vertical:3"
  data-view-path={viewPath}
 style={{'--mt-3-BDrNi': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<Settings
  viewPath={`${viewPath}/Settings`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}